import { render, staticRenderFns } from "./RepartidoresList.vue?vue&type=template&id=32d191d7&"
import script from "./RepartidoresList.vue?vue&type=script&lang=js&"
export * from "./RepartidoresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports